import { Collapse } from 'bootstrap50';

$.nette.ext('jsplugins', {
	success: function (payload) {
		if (payload.snippets !== undefined) {
			let snippets = payload.snippets;

			for (let key in snippets) {
				// skip loop if the property is from prototype
				if (!snippets.hasOwnProperty(key))
					continue;

				initPlugins($("#" + key));
			}
		}
	}
});

$.nette.ext('javascript', {
	success: function (payload) {
		if (payload.javascript) {
			eval(payload.javascript);
		}
	}
});

$.nette.ext('history', {
	success: function (payload) {
		if (payload.url !== undefined) {
			history.replaceState({}, document.title, payload.url);
		}
	}
});

$.nette.init();

initPlugins($(document));

$(window).on("load", function(){
	// $('.grid').isotope({
	// 	itemSelector: '.grid-item',
	// 	percentPosition: true,
	// 	masonry: {
	// 		columnWidth: '.grid-sizer',
	// 		gutter: '.gutter-sizer'
	// 	}
	// });
});


function initPlugins(scope){

	//Slider
	$('.carousel', scope).carousel();

	//Fancybox for images inserted by tinyMCE
	$(".tinyMceText img", scope).wrap(function (foo) {
		if(!$(this).parent().is("a")) {
			return "<a href='" + $(this).attr("src") + "' data-fancybox/>";
		}
	}).addClass("img-fluid");

	//Justified gallery
	$(".justified-gallery", scope).justifiedGallery({
		rowHeight : 180,
		lastRow : 'nojustify',
		margins : 32
	});

	//complex vertical menu
	$(".complex-vertical-menu", scope).each(function(){
		let submenu = $(this);
		$(".toggleSubmenu", submenu).on("click", function(){
			return false;
		})
	});

	//Submit on change
	$(".submitOnChange", scope).change(function(){
		$(this).closest("form").submit();
	});

	let $flashMessage = $(".flash-message");
	$flashMessage.modal("show");
}
